/* ================================================================
   LegBilligt — Klassegaven (.lbkg)
   Egen fil, fordi den kan blande nye forslag frem: "Find 4 nye forslag".
   VIGTIGT: skal indlæses FOR lb-gave2.js. Den saetter data-klar pa
   sektionen, sa lb-gave2.js springer den over og de to ikke slas om
   den samme boks.
   ================================================================ */
(function(){
  'use strict';

  var BRED = 380, VENT = 600;

  /* KILDEN — rettet 18-09-2026 fra 'gaveideer' til 'gaver-paa-lager'.
     'gaveideer' har 8.500 varer og er sorteret efter mest solgte. Butikken
     har endnu ingen ordrer, saa Shopify falder tilbage paa nyeste foerst,
     og de nyeste 1.039 varer er alle udsolgt. Derfor var hele de foerste
     500 raekker i feedet udsolgte, puljen blev tom, og Klassegaven svarede
     "Vi kunne ikke finde noget under X kr." uanset hvilket beloeb man skrev.
     'gaver-paa-lager' er en automatisk kollektion: tag 'gave' OG lager > 0.
     Den holder sig selv opdateret, og hver vare i den kan koebes.
     Bemaerk: filter.v.availability=1 virker IKKE paa 'gaveideer' — den er
     for stor til Shopifys butiksfacade-filtre. Derfor en kollektion. */
  var KILDE = 'gaver-paa-lager';
  var HJERTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z"/></svg>';
  var pulje = null, henter = null;

  function laes(){ try { return JSON.parse(localStorage.getItem('lb_onsker')) || []; } catch(e){ return []; } }
  function paaSedlen(h){ return laes().indexOf(h) > -1; }
  function kr(n){ return n.toFixed(2).replace('.', ',') + ' kr'; }
  function heltal(n){ return String(Math.round(n)); }

  function lille(src, b){
    if(!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + b;
  }
  function forhent(u){ if(u){ var i = new Image(); i.decoding = 'async'; i.src = u; } }

  function klargoer(varer, naar){
    var mangler = varer.length, kaldt = false;
    function faerdig(){ if(!kaldt){ kaldt = true; naar(); } }
    if(!mangler){ faerdig(); return; }
    setTimeout(faerdig, VENT);
    varer.forEach(function(v){
      var i = new Image();
      i.decoding = 'async';
      i.onload = function(){ if(--mangler <= 0) faerdig(); };
      i.onerror = function(){ if(--mangler <= 0) faerdig(); };
      i.src = v.bil;
    });
  }

  function normaliser(p){
    var v = null, i;
    for(i = 0; i < p.variants.length; i++){
      if(p.variants[i].available){ v = p.variants[i]; break; }
    }
    if(!v) return null;
    var pris = parseFloat(v.price);
    if(!(pris > 0)) return null;
    var raa = (p.images && p.images[0]) ? p.images[0].src : '';
    if(!raa) return null;
    return { id: v.id, handle: p.handle, titel: p.title,
             url: '/products/' + p.handle, pris: pris,
             bil: lille(raa, BRED), flere: p.variants.length > 1 };
  }

  function hentAlle(){
    if(pulje) return Promise.resolve(pulje);
    if(henter) return henter;
    henter = Promise.all([1, 2].map(function(s){
      return fetch('/collections/' + KILDE + '/products.json?limit=250&page=' + s)
        .then(function(r){ return r.ok ? r.json() : {products:[]}; })
        .catch(function(){ return {products:[]}; });
    })).then(function(svar){
      var ud = [];
      svar.forEach(function(s){
        (s.products || []).forEach(function(p){
          var n = normaliser(p);
          if(n) ud.push(n);
        });
      });
      pulje = ud;
      return ud;
    });
    return henter;
  }

  function bland(a){
    for(var i = a.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function tonInd(rod){
    function faerdig(im){
      im.classList.add('klar');
      if(im.parentNode && im.parentNode.classList) im.parentNode.classList.add('klar');
    }
    rod.querySelectorAll('.im img').forEach(function(im){
      if(im.complete && im.naturalWidth > 0){ faerdig(im); return; }
      im.addEventListener('load', function(){ faerdig(im); });
      im.addEventListener('error', function(){ faerdig(im); });
    });
  }

  function kortHtml(v){
    return '<a class="lbgf-k" href="' + v.url + '">' +
             '<span class="im" style="position:relative">' +
               '<img src="' + v.bil + '" alt="" decoding="async">' +
               '<button type="button" class="lbo-hj' + (paaSedlen(v.handle) ? ' paa' : '') +
                 '" data-h="' + v.handle + '" aria-label="Sæt på ønskesedlen">' + HJERTE + '</button>' +
             '</span>' +
             '<h4>' + v.titel + '</h4>' +
             '<div class="pr">' + kr(v.pris) + '</div>' +
             (v.flere
               ? '<span class="lbbr-kurv lbbr-kurv--v">Vælg variant</span>'
               : '<button type="button" class="lbbr-kurv" data-v="' + v.id + '">Læg i kurv</button>') +
           '</a>';
  }

  function saet(rod){
    if(rod.dataset.klar) return;
    rod.dataset.klar = '1';

    var antal = rod.querySelector('.lbkg-antal');
    var pr    = rod.querySelector('.lbkg-pr');
    var goKn  = rod.querySelector('.lbkg-go');
    var regne = rod.querySelector('.lbkg-regne');
    var res   = rod.querySelector('.lbkg-res');
    var brugt = [];

    function total(){
      var a = parseInt(antal.value, 10) || 0;
      var b = parseInt(pr.value, 10) || 0;
      return a * b;
    }

    function visRegne(){
      var a = parseInt(antal.value, 10) || 0;
      var b = parseInt(pr.value, 10) || 0;
      regne.innerHTML = a > 0 && b > 0
        ? '<b>' + a + '</b> børn &times; <b>' + b + ' kr.</b> = <b>' + total() + ' kr.</b> at handle for'
        : 'Skriv hvor mange I er, og hvad hver lægger.';
    }

    function muligeVarer(t){
      var m = pulje.filter(function(v){ return v.pris <= t + 0.001 && v.pris >= t * 0.6; });
      if(m.length < 4) m = pulje.filter(function(v){ return v.pris <= t + 0.001 && v.pris >= t * 0.35; });
      if(m.length < 4) m = pulje.filter(function(v){ return v.pris <= t + 0.001; });
      return m;
    }

    function vaelg(m, nye){
      if(!nye){
        return m.slice(0).sort(function(x, y){ return y.pris - x.pris; }).slice(0, 4);
      }
      var friske = m.filter(function(v){ return brugt.indexOf(v.handle) === -1; });
      if(friske.length < 4){ brugt = []; friske = m.slice(0); }
      return bland(friske).slice(0, 4).sort(function(x, y){ return y.pris - x.pris; });
    }

    function find(nye){
      var t = total();
      visRegne();
      if(!(t > 0)) return;
      if(!res.querySelector('.lbkg-fire')){
        res.innerHTML = '<p class="lbgf-vent">Finder gaver til ' + t + ' kr. …</p>';
      }
      hentAlle().then(function(){
        var m = muligeVarer(t);
        if(!m.length){
          res.innerHTML = '<p class="lbgf-vent">Vi kunne ikke finde noget under ' + t + ' kr. Prøv et højere beløb.</p>';
          return;
        }
        var fire = vaelg(m, nye);
        fire.forEach(function(v){ if(brugt.indexOf(v.handle) === -1) brugt.push(v.handle); });
        klargoer(fire, function(){ vis(fire, t); });
        vaelg(m, true).forEach(function(v){ forhent(v.bil); });
      });
    }

    function vis(varer, t){
      var h = '<div class="lbkg-fire">';
      varer.forEach(function(v){
        var rest = t - v.pris;
        h += '<div class="lbkg-boks">' + kortHtml(v) +
             '<div class="lbkg-rest">' + (rest < 1 ? 'Rammer beløbet præcist'
               : heltal(rest) + ' kr. tilbage til kort og indpakning') + '</div></div>';
      });
      h += '</div><div class="lbgf-bund">' +
             '<button type="button" class="lbkg-igen">Find 4 nye forslag</button>' +
           '</div>';
      res.innerHTML = h;
      tonInd(res);
      res.querySelector('.lbkg-igen').addEventListener('click', function(){ find(true); });
    }

    antal.addEventListener('input', visRegne);
    pr.addEventListener('input', visRegne);
    antal.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); find(false); } });
    pr.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); find(false); } });
    goKn.addEventListener('click', function(){ find(false); });
    visRegne();

    /* hent puljen i baggrunden nar sektionen naermer sig */
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(p){
        p.forEach(function(x){ if(x.isIntersecting){ io.disconnect(); hentAlle(); } });
      }, { rootMargin: '600px 0px' });
      io.observe(rod);
    }
  }

  function start(){
    document.querySelectorAll('.lbkg').forEach(saet);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();